import React, { useEffect, useState } from "react"
import Table from "../../components/Common/Table"
import { translations } from "../../utils/Translation/staticTranslation"
import { CategoriesApi } from "../../Apis/categories"
import { Spin } from "antd"

const Categories = () => {
  const lang = localStorage.getItem("language") || "ar"
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  const categoryLabel = translations[lang]?.Sidebar?.Categories || "Category"

  const columns = [
    { label: "#", dataKey: "index" },
    {
      label: categoryLabel,
      dataKey: lang === "ar" ? "label_ar" : "label_en",
    },
  ]

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categories = await CategoriesApi.getCategories()

        const formatted = categories.map((item, index) => ({
          index: index + 1,
          label_en: item.english,
          label_ar: item.arabic,
        }))

        setData(formatted)
      } catch (err) {
        console.error("Failed to load categories", err)
      } finally {
        setLoading(false)
      }
    }

    fetchCategories()
  }, [])

  return (
    <div className="main-category-container">
      <h2 style={{ marginBottom: "20px" }}>{categoryLabel}</h2>

      {loading ? (
        <div
          style={{
            height: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin size="large" />
        </div>
      ) : data.length > 0 ? (
        <Table columns={columns} data={data} />
      ) : (
        <div
          style={{
            height: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "16px",
            color: "#888",
          }}
        >
          No categories found.
        </div>
      )}
    </div>
  )
}

export default Categories
